import { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import UserContext from '../UserContext'

export default function TryLogin() {
  const history = useHistory();
  const { mode } = useContext(UserContext)
  // setting the theme
  const [dark, setDark] = useState(false)
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode") ? JSON.parse(localStorage.getItem("darkmode")) : false
    setDark(darkmode)
  }, [mode])
  return (
    <div className={dark ? "container trylogin-container shadow-sm darkmode" : "container trylogin-container shadow-sm"}>
      <h3>Try Twika</h3>
      <ul className="list-unstyled">
        <li>Get free access to hundred of stories.</li>
        <li>Enjoy unlimited talk with hundred hommies.</li>
        <li>We want to make you happy.</li>
      </ul>

      <button
        className="bg-fire ml-3 hover:opacity-50 hover:text-white"
        onClick={() => {
          history.push("/register");
        }}
      >
        Create account now
      </button>
      <p className="pl-3">
        Already have any account? <Link to="/login">Sign in.</Link>
      </p>
    </div>
  );
}
